// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__2fHlz","copyright":"footer_copyright__36sUg","footerLinks":"footer_footerLinks__1MUuS","link":"footer_link__3779Q","separator":"footer_separator__3H2je"};